import { DOCUMENT_TYPE_MASKS } from './document.util'
import {
  CELLPHONE_MASK_REGEX,
  ONLY_NUMBER_REGEX,
  PHONE_PREFIX_MASKING_REGEX,
  TELEPHONE_MASK_REGEX,
} from './regex.util'

const AAAPAI_FIRST_PLACE_MASK = '$1-$2'
const AAAPAI_SECOND_PLACE_MASK = '$1/$2'

const PHONE_PLACE_MASK = '($1) $2-'
const PHONE_PREFIX_PLACE_MASK = '($1) '

// '000-00000/0000'
export const aaapaiMask = (value: string): string => {
  if (!value) return value
  return value
    .replace(ONLY_NUMBER_REGEX, '')
    .replace(/(\d{3})(\d)/, AAAPAI_FIRST_PLACE_MASK)
    .replace(/(\d{5})(\d)/, AAAPAI_SECOND_PLACE_MASK)
}

export const phoneMask = (value?: string | null): string => {
  if (!value) return ''

  const cleanedValue = value.replace(ONLY_NUMBER_REGEX, '')

  if (cleanedValue.length === 10) {
    return cleanedValue.replace(TELEPHONE_MASK_REGEX, PHONE_PLACE_MASK)
  } else if (cleanedValue.length === 11) {
    return cleanedValue.replace(CELLPHONE_MASK_REGEX, PHONE_PLACE_MASK)
  } else if (cleanedValue.length > 2 && cleanedValue.length < 10) {
    return cleanedValue.replace(PHONE_PREFIX_MASKING_REGEX, PHONE_PREFIX_PLACE_MASK)
  }
  return cleanedValue
}

export const documentMask = (typeId?: string | null, number?: string | null): string => {
  if (!typeId || !number) return ''

  const documentType = DOCUMENT_TYPE_MASKS[typeId]
  const cleanedValue = number.replace(ONLY_NUMBER_REGEX, '')

  if (documentType) {
    return cleanedValue.replace(documentType.regex, documentType.mask)
  }

  return cleanedValue
}

export const cnjMask = (numeroCnj?: string | null) => {
  if (!numeroCnj) return ''

  // Remove todos os caracteres não numéricos
  const numeroLimpo = numeroCnj.replace(/\D/g, '')

  // Aplica a máscara incrementalmente, conforme a quantidade de dígitos inseridos
  if (numeroLimpo.length <= 7) {
    return numeroLimpo
  } else if (numeroLimpo.length <= 9) {
    return numeroLimpo.replace(/^(\d{7})(\d{0,2})/, '$1.$2')
  } else if (numeroLimpo.length <= 13) {
    return numeroLimpo.replace(/^(\d{7})(\d{2})(\d{0,4})/, '$1.$2.$3')
  } else if (numeroLimpo.length <= 14) {
    return numeroLimpo.replace(/^(\d{7})(\d{2})(\d{4})(\d{0,1})/, '$1.$2.$3.$4')
  } else if (numeroLimpo.length <= 16) {
    return numeroLimpo.replace(/^(\d{7})(\d{2})(\d{4})(\d{1})(\d{0,2})/, '$1.$2.$3.$4.$5')
  } else {
    return numeroLimpo.replace(/^(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{0,4})/, '$1.$2.$3.$4.$5.$6')
  }
}

export const convertNumbersOnly = (value?: string | null) => {
  if (!value) return null
  return value.replaceAll(ONLY_NUMBER_REGEX, '')
}
